<template>
  <div>
    <div class="p-8">
      <div class="max-w-7xl mx-auto">
        <div class="md:flex md:items-center md:justify-between">
          <div class="flex-1 min-w-0">
            <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
              Email Campaigns
            </h2>
          </div>

          <div
            v-if="$membershipHasPermissionTo('create email campaigns')"
            class="mt-4 flex md:mt-0 md:ml-4 space-x-2"
          >
            <CreateNewEmailCampaignAction
              :account-id="accountId"
              @created="handleEmailCampaignCreated"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="p-8">
      <div class="max-w-7xl mx-auto">
        <EmailCampaignList :key="lastRefreshedAt" :account-id="accountId" />
      </div>
    </div>
  </div>
</template>

<script>
import components from './components';

export default {
  components,
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      lastRefreshedAt: new Date().getTime(),
    };
  },
  methods: {
    handleEmailCampaignCreated() {
      this.lastRefreshedAt = new Date().getTime();
    },
  },
};
</script>
